// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"ce9c1162","385":"fbe16dec","418":"af40f2b5","495":"77f04df2","496":"b58ae5d8","625":"1cc7871d"}[chunkId] + ".chunk.js";
};